import { isKlarnaSupported } from "~/components/stripe";
import { ListingData, useListingData } from "~/context/ListingPageDataContext";

const useIsKlarnaSupported = () => {
  const { data: listingData = {} as ListingData } = useListingData();

  return isKlarnaSupported(
    listingData.listingCurrency,
    listingData.listingCountry,
  );
};

export { useIsKlarnaSupported };
